import logo from './logo.svg';
import './App.css';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link
} from "react-router-dom";
import Login from './components/Login/Login';
import Mainpage from './components/Mainpage/Mainpage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Brmain from './components/Brmain/Brmain';
import Newregi from './components/Newregi/Newregi';
import Branchprofiles from './components/Branchprofiles/Branchprofiles';
import Sample from './components/Sample/Sample';
import Feedbackmain from './components/Feedbackmain/Feedbackmain';
import Feedbackdetails from './components/Feedbackdetails/Feedbackdetails';
import Todayfeedlist from './components/Todayfeedlist/Todayfeedlist';
import Madh from './components/Madh/Madh';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/customer" element={<Login />} />
          <Route path="/Mainpage" element={<Mainpage />} />
          <Route path="/brmain" element={<Brmain />} />
          <Route path="/newregi" element={<Newregi />} />
          <Route path="/prlist" element={<Branchprofiles />} />
          <Route path="/feedback" element={<Feedbackmain />} />
          <Route path="/todayfeedback" element={<Todayfeedlist />} />
          <Route path="/madh" element={<Madh />} />
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
